import React from "react";

import {
  toRgbStruct,
  toRgbaStruct,
  hexToStruct,
  hexaToStruct,
  isDarkColor,
  rgbToStruct,
  rgbaToStruct,
} from "../lib/colorMath";
import Background from "./backgroud";
import Overlay from "./overlay";
import Dab from "./dab";
import DabSVG from "./dabSVG";
import Article from "./article";

class Root extends React.Component {
  state = {
    background: "rgb(255, 255, 224)",
    overlay: [
      { color: "rgba(255, 128, 128, 0.8)", key: "#1", nb: 1 },
      { color: "rgba(0, 0, 255, 0.5)", key: "#2", nb: 2 },
      //      { color: "rgba(0, 255, 0, .5)", key: "#3", nb: 3 },
    ],
  };
  /*
  calculator = (
    <div
      style={{
        display: "flex",
        justifyContent: "right",
        position: "relative",
      }}
    >
      <div
        id="calculator"
        style={{
          position: "absolute",
          marginTop: "-50px",
          marginRight: "70px",
        }}
      >
        <h2>Calculate final color</h2>

        <div className="form-container">
          <Background
            onChange={this.backgroundChange}
            value={this.state.background}
            struct={hexToStruct(this.state.background)}
          />
          {this.state.overlay.map((e) => (
            <Overlay
              key={e.key}
              item={e}
              onDelete={this.onOverlayDelete}
              onChange={this.overlayChange}
              struct={hexaToStruct(e.color)}
            />
          ))}
        </div>
        {this.state.overlay.length < 3 ? (
          <div style={{ marginBottom: "24px" }}>
            <button onClick={this.addOverlay}>
              Add layer with opacity -{this.state.overlay.length}
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
  */

  keyCounter = 3;

  dabsSVG = [
    /*
    {
      img: "#svg11",
      top: "16%",
      className: "svg11",
    },
    {
      img: "#svg31",
      top: "33%",
      className: "svg31",
    },
    {
      img: "#svg21",
      top: "16%",
      className: "svg21",
    },
*/
    {
      img: "#dab1_svg",
      top: "16%",
      className: "svg11",
    },
    {
      img: "#dab2_svg",
      top: "33%",
      className: "svg21",
    },
    {
      img: "#dab3_svg",
      top: "16%",
      className: "svg31",
    },
  ];
  dabKey = 0;

  componentDidMount() {
    console.log("root mount");
  }

  initialColor = [
    "rgba(255, 128, 128, 0.8)",
    "rgba(0, 0, 255, 0.5)",
    "rgba(0, 255, 0, .5)",
  ];

  addOverlay = () => {
    const key = `overlay ${this.keyCounter++}`;
    const o = this.state.overlay;
    o.push({
      color: this.initialColor[this.state.overlay.length],
      key,
      nb: this.state.overlay.length + 1,
    });

    this.setState({
      overlay: o,
    });
  };

  onOverlayDelete = (nb) => {
    const o = this.state.overlay.filter((e) => e.nb !== nb);
    for (let i = 0; i < o.length; i++) {
      o[i].nb = i + 1;
    }
    this.setState({ overlay: o });
  };

  backgroundChange = (color) => {
    this.setState({ background: color });
  };
  overlayChange = (key, color) => {
    const o = this.state.overlay;
    o.forEach((e) => {
      if (e.key === key) {
        e.color = color;
      }
    });
    this.setState({
      overlay: o,
    });
  };

  getFinalColor = () => {
    let finalColor = { r: 255, g: 255, b: 255 };
    if (toRgbStruct(this.state.background)) {
      finalColor = toRgbStruct(this.state.background);

      for (const o of this.state.overlay) {
        if (toRgbaStruct(o.color)) {
          const c = toRgbaStruct(o.color);
          finalColor.r = (finalColor.r * (1 - c.a) + c.r * c.a).toFixed();
          finalColor.g = (finalColor.g * (1 - c.a) + c.g * c.a).toFixed();
          finalColor.b = (finalColor.b * (1 - c.a) + c.b * c.a).toFixed();
        } else {
          finalColor = null;
          break;
        }
      }
    } else {
      finalColor = null;
    }

    if (finalColor == null) {
      return ["not a color", "not a color", finalColor];
    }

    return [
      `rgb(${finalColor.r}, ${finalColor.g}, ${finalColor.b})`,
      `#${parseInt(finalColor.r).toString(16)}${parseInt(finalColor.g).toString(
        16
      )}${parseInt(finalColor.b).toString(16)}`,
      finalColor,
    ];
  };

  reducer = (height, dab) => {
    console.log(height, dab.height);
    const result = Math.max(height, dab.height);
    return result;
  };
  render() {
    let dab_offset = 0;
    let imageCounter = 0;
    const finalColor = this.getFinalColor();
    const textColor = isDarkColor(finalColor[2]) ? "white" : "black";
    console.log("textColor ", textColor);

    const fillLines = [];

    for (let i = 0; i < 2 - this.state.overlay.length; i++) {
      fillLines.push("");
    }

    const rightOffset = 460;

    return (
      <React.Fragment>
        <div style={{ background: this.state.background }}>
          <div
            style={{
              maxWidth: "1000px",
              margin: "0 auto",
              position: "relative",
              // background: this.state.background,
            }}
          >
            <div style={{ width: "100%", paddingTop: "40%" }}>
              {this.state.overlay.map((e) => (
                <DabSVG
                  color={toRgbaStruct(e.color)}
                  img={this.dabsSVG[imageCounter % 3].img}
                  text={`${e.key} ${e.color}`}
                  dab={this.dabsSVG[imageCounter++ % 3]}
                  offset={(dab_offset += 50)}
                  key={`${e.key} ${e.color}`}
                ></DabSVG>
              ))}
              <span
                style={{
                  color: textColor,
                  position: "absolute",
                  left: "40%",
                  top: "45%",
                  fontSize: 24,
                  fontWeight: "bold",
                }}
              >
                {finalColor[0]}
              </span>
            </div>
          </div>
        </div>

        <div style={{ position: "relative", overflowX: "hidden" }}>
          <div
            style={{ width: "100%", height: 136, backgroundColor: "blue" }}
          ></div>
          <div
            style={{ display: "flex", filter: "blur(10px)", margin: "0 -10px" }}
          >
            <div
              style={{
                background: "rgb(153,153,153)",
                flexGrow: 1,
                height: 60,
              }}
            ></div>
            <div>
              <div
                style={{
                  width: "137px",
                  height: 60,
                  background: "rgb(153,153,153)",
                }}
              ></div>
              <svg style={{ width: "137px", fill: "rgb(153,153,153)" }}>
                <use href="#slant"></use>
              </svg>
            </div>
            <div
              style={{
                background: "rgba(0,0,0,0.4)",
                width: rightOffset + 10,
                height: 192,
              }}
            ></div>
          </div>

          {/*   */}

          <div style={{ position: "absolute", top: 0, left: 0, right: 0 }}>
            <div
              style={{
                widht: "100%",
                height: 166,
                backgroundColor: this.state.background,
              }}
            ></div>

            <div
              style={{
                display: "flex",
              }}
            >
              <div
                style={{ flexGrow: 1, height: 0, background: "white" }}
              ></div>
              <div>
                <svg
                  style={{
                    width: "137px",
                    height: 132,
                    fill: this.state.background,
                  }}
                >
                  <use href="#slant"></use>
                </svg>
              </div>
              <div
                style={{
                  width: rightOffset,
                  height: "132px",
                  background: this.state.background,
                }}
              >
                {/*------------------------------------*/}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    position: "relative",
                    border: "red 2px",
                  }}
                >
                  {/*
                  <div
                    id="calculator"
                    style={{
                      position: "absolute",
                      marginTop: "-50px",
                      marginRight: "70px",
                      backgroundImage: "url(hexa.svg)",
                    }}
                  >
                    <h2>Calculate final color</h2>

                    <div className="form-container">
                      <Background
                        onChange={this.backgroundChange}
                        value={this.state.background}
                        struct={hexToStruct(this.state.background)}
                      />
                      {this.state.overlay.map((e) => (
                        <Overlay
                          key={e.key}
                          item={e}
                          onDelete={this.onOverlayDelete}
                          onChange={this.overlayChange}
                          struct={hexaToStruct(e.color)}
                        />
                      ))}
                    </div>
                    {this.state.overlay.length < 3 ? (
                      <div style={{ marginBottom: "24px" }}>
                        <button
                          onClick={this.addOverlay}
                          style={{
                            background: "none",
                            border: "none",
                            fontSize: 16,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          Add layer with opacity
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  */}
                </div>

                {/*------------------------------------*/}
              </div>
            </div>
          </div>

          {/*  */}
          <div
            id="calculator"
            style={{
              position: "absolute",
              top: 0,
              right: rightOffset - 430,
              backgroundImage: "url(hexa.svg)",
              width: "513px",
              height: "271px",
              padding: "40px 0 0 96px",
            }}
          >
            <h2>Calculate equivalent color</h2>

            <div className="form-container">
              <Background
                onChange={this.backgroundChange}
                value={this.state.background}
                struct={hexToStruct(this.state.background)}
              />
              {this.state.overlay.map((e) => (
                <Overlay
                  key={e.key}
                  item={e}
                  onDelete={this.onOverlayDelete}
                  onChange={this.overlayChange}
                  struct={hexaToStruct(e.color)}
                />
              ))}
              {fillLines.map((e) => (
                <div style={{ gridColumn: 1, height: 20.4 }}> </div>
              ))}
              {this.state.overlay.length < 3 && (
                <div style={{ marginBottom: "24px", gridColumn: "1/ span 3" }}>
                  <button
                    onClick={this.addOverlay}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: 16,
                      textDecoration: "underline",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    Add layer with opacity
                  </button>
                </div>
              )}
            </div>
            {/* this.state.overlay.length < 3 ? (
              <div style={{ marginBottom: "24px" }}>
                <button
                  onClick={this.addOverlay}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: 16,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Add layer with opacity
                </button>
              </div>
            ) : (
              ""
            ) */}
          </div>
        </div>

        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",

            display: "flex",
            flexWrap: 1,
            justifyContent: "space-between",
          }}
        >
          <Article />
        </div>
      </React.Fragment>
    );
  }
}

export default Root;

/*

        <div
          style={{
            background: this.state.background,
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            margin: "25px",
            padding: "25px",
          }}
        >
          <div
            style={{
              background: finalColor[0],
              width: "50px",
              height: "50px",
              borderRadius: "50%",
            }}
          ></div>
        </div>





> r
/rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/
> s="rgb(255,17,5)";
'rgb(255,17,5)'
> match=r.exec(s);
[
  'rgb(255,17,5)',
  '255',
  '17',
  '5',
  index: 0,
  input: 'rgb(255,17,5)',
  groups: undefined
]
>


r  = /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/


> r  = /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/
/rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/
> r
/rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/
> sa=rgba(255,128,60,.8);
Uncaught ReferenceError: rgba is not defined
> sa="rgba(255,128,60,.8)";
'rgba(255,128,60,.8)'
> match=r.exec(sa);
[
  'rgba(255,128,60,.8)',
  '255',
  '128',
  '60',
  '.8',
  index: 0,
  input: 'rgba(255,128,60,.8)',
  groups: undefined
]

// check 1-3 >=0 and <=255
// 4 
!isNaN && >= 0 && <=1


function hexToStruct(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function hexaToStruct(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.trim()
  );
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: (parseInt(result[4], 16).toFixed(2) / 255.0).toFixed(2),
      }
    : null;
}

function rgbToStruct(rgb) {
  const re = /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
  const match = re.exec(rgb);
  if (!match) {
    return null;
  }
  const r = match[1];
  const g = match[2];
  const b = match[3];
  if (r < 0 || r > 255) {
    return null;
  }
  if (g < 0 || g > 255) {
    return null;
  }
  if (b < 0 || b > 255) {
    return null;
  }

  return { r, g, b };
}

function rgbaToStruct(rgb) {
  const re = /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,(.*)\)$/;
  const match = re.exec(rgb);
  if (!match) {
    return null;
  }
  const r = match[1];
  const g = match[2];
  const b = match[3];
  const a = match[4];

  if (r < 0 || r > 255) {
    return null;
  }
  if (g < 0 || g > 255) {
    return null;
  }
  if (b < 0 || b > 255) {
    return null;
  }

  if (a < 0 || a > 1) {
    return null;
  }

  return { r, g, b, a };
}


        
        <Dab
          color={finalColor[0]}
          offset="0"
          final
          img={this.dabs[0].img}
          dab={this.dabs[0]}
          text={`${finalColor[0]} ${finalColor[1]}`}
          key={++this.dabKey}
        ></Dab>

        <div style={{ display: "none" }}>
          Color={finalColor[0]} {finalColor[1]}
        </div>

*/

/*

  dabs1 = [
    {
      img: "11.png",
      top: 0,
      left: 0,
      width: 1030,
      height: 350,
    },
    {
      img: "31.png",
      top: 0,
      left: 160,
      width: 888,
      height: 302,
    },
    {
      img: "21.png",
      top: 0,
      left: 368,
      width: 838,
      height: 295,
    },
  ];

    dabs = [
    {
      img: "11.png",
      left: 0,
      top: 135,
      width: 1030,
      height: 350,
      textLeft: -907,
      textTop: 68,
    },
    {
      img: "31.png",
      left: 160,
      top: 237,
      width: 888,
      height: 302,
      textLeft: -522,
      textTop: 209,
    },
    {
      img: "21.png",
      left: 368,
      top: 135,
      width: 838,
      height: 295,
      textLeft: -220,
      textTop: 68,
    },
  ];
              <DabSVG
                color={toRgbStruct(this.state.background)}
                text={this.state.background}
                img={this.dabsSVG[imageCounter % 3].img}
                dab={this.dabsSVG[imageCounter++ % 3]}
                key={`background ${this.state.background}`}
              ></DabSVG>


*/
